import React, { Component, Fragment } from 'react';
import { Button, Checkbox, DatePicker, Input, message, Popconfirm, Tooltip } from 'antd';
import * as Func from '../../../../../helpers/functions';
import {
    checkUndefine,
    multipleValidate,
    formatValidation,
    vietnameseStringToUnicode,
} from '../../../../../helpers/functions';
import { ALL_CURRENCY_ENUM, DATE_TIME_FORMAT, DEFAULT_TOUR_PROPERTY, ORDER, PAYMENTS_GATEWAY, PAYMENTS_GATEWAY_SALE_ORDER, SALE_CHANNELS } from '../../../../../constants/Define';

import Modal from '../../../common/component/Modal';

import SaleOrderModel from '../../../../../models/SaleOrder';
import { cloneDeep, find, get, minBy, sumBy } from 'lodash';
import {  Tabs, Icon } from 'antd'

import DEFINE from "../../../../../constants/Define";
import './SaleOrder.less';
import moment from 'moment';
import Wrapper from '../../../common/component/Wrapper';
import { FormWrapperInputComponent, ListComponent, StatusComponent } from '../../../common/component/Index';
import AntSelect, { AntOption } from '../../../common/component/AntSelect';
import ModalSKU from './ModalSKU/ModalSKU';
import TextArea from 'antd/lib/input/TextArea';

let permisionActions = [];
let displayMonth = null;
const { TabPane } = Tabs;
const another = [
    { 
        label: 'Gửi Email', 
        value: 'isSendEmail' 
    },
]

const ListCols = ['id', 'tourName', 'ticketName', 'orderItemType', 'objectType', 'salePrice', 'quantity', 'usingDate', 'returnDate', 'lengthOfTour']
const ModelObjectFields = ['id', 'tourName', 'ticketName', 'orderItemType', 'objectType', 'salePrice', 'quantity', 'usingDate', 'returnDate', 'lengthOfTour']

const acceptFtCode = ['transfer', 'paylater', 'popr'] // Chuyển khoản - Trả sau - POPR

const initState = {
    validation: {},
    validationTour: {},
    saleOrder: new SaleOrderModel(),
    ticketState: [],
    listTicketAdded: [],
    couponData: {},
    isOpen: false,
    dataSKU: {},
    lengthOfTour: 0,
    totalPrice: 0,
    customerState: [],
    listCustomerAdded: [],
    validationCustomer: [],
    validationSessionZone: {},
    isValidSubmarineQuantity: true 
}

export default class SaleOrder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...cloneDeep(initState),
            ticketTable: {
                titleTable: Func.getTitleTable(ListCols, ['action'], ['id', 'lengthOfTour']),
                modelTicket: ModelObjectFields,
                componentTable: {
                    objectType: {
                        render: (value, record) => value.name,
                    },
                    salePrice: {
                        render: (value, record) => Func.formatMoney(value)
                    },
                    usingDate: {
                        render: (value, record) => value && moment(moment.utc(value).toDate()).format(DATE_TIME_FORMAT.SHORT_DATE)
                    },
                    returnDate: {
                        render: (value, record) => record.usingDate && moment(record.usingDate)
                        .add(Math.floor(record.lengthOfTour || 1) - 1, 'days')
                        .format(DATE_TIME_FORMAT.SHORT_DATE)
                    },
                    orderItemType: {
                        render: (value, record) => (
                            <Fragment>
                                    {value && <div className="g-mt-5">
                                            <StatusComponent color={value === 7 ? 'orange' : (value === 1 ? 'blue' : 'green') }
                                                label={this.props.t(`item.tour.types.${value === 7 ? 'vinwonder' : value === 1 ? 'voucher' : 'tour' }`)} />
                                    </div>
                                    }
                                </Fragment>
                        )
                    },
                    action: {
                        align: 'right',
                        width: 100,
                        render: (text, record, index) => (
                            <Popconfirm 
                                placement="top" 
                                title={this.props.t('notification.sureRemove')} 
                                okText={this.props.t(`action.remove`)}
                                cancelText={this.props.t(`action.cancel`)}
                                onConfirm={() => this.onRemoveTicket(record.id)}
                            >
                                <Tooltip title={ this.props.t(`action.remove`) }>
                                    <Button>
                                        <Icon type="delete"/>
                                    </Button>
                                </Tooltip>
                            </Popconfirm>
                        )
                        
                    },
                },
            }
        };
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.ORDER);
        this.initSaleOrder()
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.visible && prevProps.visible !== this.props.visible) {
            this.initSaleOrder()
        }
        if (this.props.orderState.isSubmitSaleOrder && prevProps.orderState.isSubmitSaleOrder !== this.props.orderState.isSubmitSaleOrder) {
            this.setState(cloneDeep(initState));
            this.props.onSubmit()
        }
        if(this.props.tourState.detail.tourLineTickets && prevProps.tourState.detail.tourLineTickets !== this.props.tourState.detail.tourLineTickets) {
            this.mappingTourlineTicket(this.props.tourState.detail.tourLineTickets)
        }

        if(this.props.tourState.detail.tour.lengthOfTour && prevProps.tourState.detail.tour.lengthOfTour !== this.props.tourState.detail.tour.lengthOfTour) {
            this.setState({ lengthOfTour: parseFloat(this.props.tourState.detail.tour.lengthOfTour) })
        }

        if(this.props.couponState.coupon && prevProps.couponState.coupon !== this.props.couponState.coupon) {
            const { couponData } = this.state
            couponData = this.props.couponState.coupon;
            this.setState({ couponData })
        }
        if (permisionActions.allowExportVoucher && another.length < 2) {
            another.push({ 
                label: 'Xuất File', value: 'exportFile' 
            })
        }

        // build customer form
        if(this.state.ticketState !== prevState.ticketState && this.state.ticketState.length) {
            this.buildCustomerForm(this.state.ticketState);
        }
    }

    render() {
        const { t, visible, groupState, orderState, tourState } = this.props;
        const { validation, validationCustomer, validationSessionZone, saleOrder, dataSKU, lengthOfTour, ticketTable, ticketTable2, ticketState, customerState, listTicketAdded, activeTab, validationTour, couponData, isOpen, totalPrice, vinWonderState } = this.state;
        const { titleTable, modelTicket, componentTable } = ticketTable;
        const { isFetchingSaleOrder } = orderState;

        return (
            <Modal className="sale-order"
                width={1200}
                destroyOnClose={true}
                maskClosable={false}
                visible={visible}
                // visible={true}
                title={t(`item.order.exportSaleOrder`)}
                onOk={this.onSubmitTour}
                okText={t(`item.order.exportSaleOrder`)}
                confirmLoading={isFetchingSaleOrder}
                onCancel={this.onCancel} cancelText={t(`action.cancel`)}
            >
                <Wrapper className="col-md-12 sale-order">
                    <Wrapper className="row">
                        <h3 className="col-md-12 m-b">Thông tin khách hàng</h3>
                        <Wrapper className="col-md-6">
                            <FormWrapperInputComponent
                                isRequired={'right'}
                                isValidation={true}
                                dataValidation={saleOrder.firstname}
                                validation={validation.firstname}
                                labelTitle={t(`item.order.firstname`)}
                            >
                                <Input
                                    type={`text`}
                                    className={`form-control`}
                                    name={`firstname`} onChange={e => this.onChange('firstname', e.target.value)}
                                    value={checkUndefine(saleOrder.firstname)} />
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-6">
                            <FormWrapperInputComponent
                                isRequired={'right'}
                                isValidation={true}
                                dataValidation={saleOrder.lastname}
                                validation={validation.lastname}
                                labelTitle={t(`item.order.lastname`)}
                            >
                                <Input
                                    type={`text`}
                                    className={`form-control text-left`}
                                    name={`lastname`} onChange={e => this.onChange('lastname', e.target.value)}
                                    value={saleOrder.lastname} />
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-6">
                            <FormWrapperInputComponent
                                isRequired={'right'}
                                isValidation={true}
                                dataValidation={saleOrder.email}
                                validation={validation.email}
                                labelTitle={t(`item.order.email`)}
                            >
                                <Input
                                    type={`text`}
                                    className={`form-control`}
                                    name={`email`} onChange={e => this.onChange('email', e.target.value)}
                                    value={checkUndefine(saleOrder.email)} />
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-6">
                            <FormWrapperInputComponent
                                isRequired={'right'}
                                isValidation={true}
                                dataValidation={saleOrder.phoneNumber}
                                validation={validation.phoneNumber}
                                labelTitle={t(`item.order.phoneNumber`)}
                            >
                                <Input
                                    disabled={isFetchingSaleOrder}
                                    type={`number`}
                                    className={`form-control text-left`}
                                    name={`phoneNumber`} onChange={e => this.onChange('phoneNumber', e.target.value)}
                                    value={saleOrder.phoneNumber} />
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-12 flex-end align-center chk-sale-voucher">
                            <Checkbox.Group options={another} defaultValue={['Gửi Email']} onChange={this.onChangeService} />
                        </Wrapper>
                        <h3 className="col-md-12 m-b m-t">
                            Đơn hàng
                        </h3>
                        <Wrapper className="col-md-6">
                            <FormWrapperInputComponent
                                isRequired={'right'}
                                isValidation={true}
                                dataValidation={saleOrder.saleChannel}
                                validation={validation.saleChannel}
                                labelTitle={t(`item.order.saleChannel`)}
                            >
                                <AntSelect className="select-payment-type"
                                    showArrow showSearch
                                    placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.order.saleChannel")).toLowerCase())}
                                    value={saleOrder.saleChannel}
                                    onChange={(e) => this.onChange('saleChannel', e)}
                                    style={{ width: '100%' }}
                                >
                                    {Object.keys(SALE_CHANNELS).map(item => (
                                        <AntOption key={item} value={SALE_CHANNELS[item]}>{t(`item.order.saleChannels.${SALE_CHANNELS[item]}`)}</AntOption>
                                    ))}
                                </AntSelect>
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-6">
                            <FormWrapperInputComponent
                                isRequired={'right'}
                                isValidation={true}
                                dataValidation={saleOrder.paymentType}
                                validation={validation.paymentType}
                                labelTitle={t(`item.order.paymentType`)}
                            >
                                <AntSelect className="select-payment-type"
                                    showArrow showSearch
                                    placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.order.paymentType")).toLowerCase())}
                                    value={saleOrder.paymentType}
                                    onChange={(e) => this.onChange('paymentType', e)}
                                    style={{ width: '100%' }}
                                >
                                    {Object.keys(PAYMENTS_GATEWAY_SALE_ORDER).map(key => (
                                        PAYMENTS_GATEWAY_SALE_ORDER[key].isActive && <AntOption key={key} value={PAYMENTS_GATEWAY_SALE_ORDER[key].value}>{t(`item.order.paymentTypes.${PAYMENTS_GATEWAY_SALE_ORDER[key].value}`)}</AntOption>
                                    ))}
                                </AntSelect>
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-12">
                            <FormWrapperInputComponent
                                labelTitle={t(`item.order.note`)}
                            >
                                <TextArea className="form-control"
                                    name="note"
                                    onChange={e => this.onChange('note', e.target.value)}
                                    value={checkUndefine(saleOrder.note)} />
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-6">
                            <FormWrapperInputComponent
                                // isRequired={'right'}
                                // isValidation={true}
                                // dataValidation={saleOrder.couponCode}
                                // validation={validation.couponCode}
                                labelTitle={t(`item.order.couponCode`)}
                            >
                                <Input
                                    type={`text`}
                                    className={`form-control`}
                                    name={`couponCode`} onChange={e => this.onChange('couponCode', e.target.value)}
                                    value={checkUndefine(saleOrder.couponCode)} />
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-6">
                            {
                                acceptFtCode.includes(saleOrder.paymentType) &&
                                <FormWrapperInputComponent
                                    // isRequired={'right'}
                                    // isValidation={true}
                                    // dataValidation={saleOrder.ftCode}
                                    // validation={validation.ftCode}
                                    labelTitle={t(`item.order.ftCode`)}
                                >
                                    <Input
                                        type={`text`}
                                        className={`form-control`}
                                        name={`ftCode`} onChange={e => this.onChange('transactionId', e.target.value)}
                                        value={checkUndefine(saleOrder.transactionId)} />
                                </FormWrapperInputComponent>
                            }
                        </Wrapper>
                        <Wrapper className="col-md-12 m-b m-t d-flex justify-content-between">
                            <h3>Chi tiết đơn hàng</h3>
                            <Button className='btn btn-primary' onClick={this.toggleShowSKU}>
                                Thêm
                            </Button>
                        </Wrapper>
                        <Wrapper className="col-md-12">
                            <ListComponent
                                tableKey="table-tour-ticket-object-type"
                                rowKey={ record => record.id }
                                dataSource={ Func.getDataSource(listTicketAdded, modelTicket) }
                                columns={ Func.columnsTable({
                                    titleTable: titleTable,
                                    component: componentTable,
                                    itemName: 'tourTicket'
                                }) }
                            />
                            <div className="text-right m-t">
                                <b>Tổng tiền: {Func.formatMoney(totalPrice)}</b>
                            </div>
                        </Wrapper>
                    </Wrapper>
                </Wrapper>
                

                <ModalSKU
                    visible={isOpen}
                    addTicket={this.addTicket}
                    onCancel={this.toggleShowSKU}
                    dataSKU={dataSKU}
                    validation={validation}
                    validationCustomer={validationCustomer}
                    validationSessionZone={validationSessionZone}
                    tourState={tourState}
                    ticketState={ticketState}
                    customerState={customerState}
                    lengthOfTour={lengthOfTour}
                    isValidSubmarineQuantity={this.state.isValidSubmarineQuantity}
                    saleOrderItems={this.state.listTicketAdded}
                    getTourDetail={this.props.getTourDetail}
                    getTourLineTickets={this.props.getTourLineTickets}
                    selectSku={this.selectSku}
                    onChangeDataSKU={this.onChangeDataSKU}
                    getListTourLines={this.props.getListTourLines}
                    clearTicket={this.clearTicket}
                    onChangeQuantityTicket={this.onChangeQuantityTicket}
                    onChangeTypeSKU={this.onChangeTypeSKU}
                    onChangeCustomer={this.onChangeCustomer}
                    getVinWonderTypes={this.props.getVinWonderTypes}
                    getVinwonderSessions={this.props.getVinwonderSessions}
                    getVinwonderZones={this.props.getVinwonderZones}
                    vinWonderState={this.props.vinWonderState}
                    saleOrder={this.state.saleOrder}
                    onChange={this.onChange}
                />
            </Modal>
        )
    }

    clearTicket = () => {
        this.setState({ ticketState: [] })
    }

    onSubmitTour = () => {
        const { listFilters } = this.props
        const { saleOrder } = this.state
        const listTicketAdded = cloneDeep(this.state.listTicketAdded || []);

        if(listTicketAdded?.length){
            listTicketAdded.forEach(item => {
                // hot fix change orderITemType of Voucher from 1 -> 2
                item.orderItemType = (item.orderItemType === 1 ? 2 : item.orderItemType);
                item.usingDate = item.usingDate ? moment(item.usingDate).format(DATE_TIME_FORMAT.SHORT_DATE_EXPORT) : undefined;
            })
        }

        if(this.validateTour()) {
            if(listTicketAdded.length === 0) {
                return message.error('Vui lòng chọn sản phẩm')
            }
            const tourExport = { ...saleOrder, saleOrderItems: listTicketAdded, customerItems: this.state.listCustomerAdded }
            this.props.exportTourSaleOrder(tourExport, listFilters);
        }
    }

    totalPriceTicket = (listTicket) => {
        const totalPrice = listTicket.reduce((pValue, cValue) => pValue + (cValue.salePrice * cValue.quantity), 0)
        this.setState({ totalPrice })
    }

    incrementTicket = (ticketSelected) => {
        const listTicketAdded = [...this.state.listTicketAdded]
        if(listTicketAdded.length === 0) {
            return ticketSelected
        }
        const tickets = [...ticketSelected]
        tickets.forEach(ticketUpdate => {
            const findTicket = listTicketAdded.findIndex(ticket => ticket.id === ticketUpdate.id && ticket.usingDate === ticketUpdate.usingDate && ticket.tourLineItemId === ticketUpdate.tourLineItemId && ticket.tourLineItemTicketId && ticketUpdate.tourLineItemTicketId)
            if(findTicket !== -1) {
                listTicketAdded[findTicket].quantity += ticketUpdate.quantity
            } else {
                listTicketAdded.push(ticketUpdate)
            }
        })

        return listTicketAdded
    }

    addTicket = () => {
        const { customerState, dataSKU } = this.state;

        if(this.validateCustomer(customerState) & (!customerState?.length || this.validateSessionZone())) {
            const ticketSelected = this.state.ticketState.filter(item => !!item.quantity)
            .map(x=> 
                ({...x, 
                    sessionId: x.sessionId || 0,
                    usingDate: dataSKU.bookingDate ? moment(dataSKU.bookingDate).format(DATE_TIME_FORMAT.SHORT_DATE_EXPORT) : undefined
                }))
            const incrementTicket = this.incrementTicket(ticketSelected)
            const incrementCustomers = [...this.state.listCustomerAdded, ...customerState]
            const newList = incrementTicket
            this.setState({ listTicketAdded: newList, listCustomerAdded: incrementCustomers, customerState: [], validationCustomer: [] })
            this.totalPriceTicket(newList)
            this.toggleShowSKU()
        }
    }

    onRemoveTicket = (ticketItemId) => {
        const ticketFiltered = this.state.listTicketAdded.filter(item => item.id !== ticketItemId)
        this.setState({
            listTicketAdded: ticketFiltered
        })

        const customerFiltered = this.state.listCustomerAdded.filter(item => item.tourTicketItemId !== ticketItemId)
        this.setState({
            listCustomerAdded: customerFiltered
        })

        this.totalPriceTicket(ticketFiltered)
    }

    onChangeQuantityTicket = (ticketItemId, value) => {
        const tickets = [...this.state.ticketState]
        const indexChange = tickets.findIndex(item => item.id === ticketItemId)
        tickets[indexChange].quantity = value
        this.setState({
            ticketState: tickets
        })
    }

    mappingTourlineTicket = (tourLineTickets) => {
        let tickets = []
        tourLineTickets.forEach((tourLine) => {
            tourLine.tourTicketItems.forEach((item) => {
                tickets.push({
                    ...item,
                    tourId: this.props.tourState.detail.tour.id,
                    skuId: this.props.tourState.detail.tour.id,
                    tourName: this.props.tourState.detail.tour.tourName,
                    orderItemType: this.props.tourState.detail.tour.type,
                    ticketName: tourLine.tourTicket.name,
                    tourLineItemId: tourLine.tourTicket.id,
                    seats: tourLine.tourTicket.seats,
                    quantity: undefined,
                    lengthOfTour: this.state.lengthOfTour,
                    usingDate: this.props.tourState.detail.tour.type === 2 ? this.state.dataSKU.bookingDate.toISOString() : undefined,
                    siteCode: tourLine?.tourTicket?.siteCode,
                    vwType: tourLine?.tourTicket?.vwType
                })
            })
        })
        this.setState({ ticketState: tickets })
    }

    selectSku = (skuId) => {
        this.onChangeDataSKU('skuId', skuId)
        this.onChangeDataSKU('bookingDate', null)
        this.setState({
            ticketState: []
        })
    }
    
    toggleShowSKU = () => {
        this.setState({ 
            isOpen: !this.state.isOpen, 
            dataSKU: {},
            ticketState: []
        })
    }

    onChangeTypeSKU = (type) => {
        this.setState({ 
            ticketState: [],
            dataSKU: {}
        })

        // this.props.getAllTour(type);
    }

    initSaleOrder = () => {
        // type voucher (1)
        this.props.getAllTour(1);
    }

    onChangeService = (result) => {
        const { saleOrder } = this.state;
        saleOrder.isSendEmail = result.includes('isSendEmail');
        saleOrder.exportFile = result.includes('exportFile');
        this.setState({ saleOrder })
    }

    onChangeServiceTour = (result) => {
        const { tourSaleOrder } = this.state;
        tourSaleOrder.isSendEmail = result.includes('isSendEmail');
        tourSaleOrder.exportFile = result.includes('exportFile');
        this.setState({ tourSaleOrder })
    }

    onSubmit = () => {
        this.onSubmit();
    }

    onSubmitVoucher = () => {
        const { couponData, saleOrder } = this.state;
        if(couponData && !couponData.isValid) {
            saleOrder.couponCode = '';
        }
        this.props.exportSaleO(saleOrder, this.props.listFilters);
    }

    onCancel = () => {
        this.setState(cloneDeep(initState));
        this.props.onCancel();
    }

    onApplyCoupon = () => {
        const { saleOrder } = this.state;
        let valueProduct = saleOrder.groupId;
        this.props.getCoupon(saleOrder.couponCode, 'TOUR', valueProduct, saleOrder.quantity)
    }

    onChangeDataSKU = (fieldName, value) => {
        const { dataSKU } = this.state;
        dataSKU[fieldName] = value;
        this.setState({ dataSKU })
    }

    onChange = (fieldName, value) => {
        const { saleOrder } = this.state;
        saleOrder[fieldName] = typeof value === 'string' || value instanceof String ? value.trimLeft() : value;
        this.setState({ saleOrder })
        // this.validateTour()
    }
    
    onChangeTicket = (fieldName, value, index) => {
        const { ticketState } = this.state;
        ticketState[index][fieldName] = value;
        this.setState({ ticketState })
    }

    onChangeSelect = (skuId) => {
        this.props.getTourDetail(skuId);
        this.onChangeDataSKU('skuId', skuId)
        this.onChangeDataSKU('bookingDate', null)
        this.props.clearCoupon()
    }

    getTotalAmount = () => {
        const { saleOrder } = this.state;
        const { groupState } = this.props;
        let totalAmount = 0;
        if (saleOrder.quantity && saleOrder.groupId && groupState.dataUpdate && groupState.dataUpdate.id) {
            const group = groupState.dataUpdate;
            const vndPrice = group.groupPrices.VND;
            if (group && vndPrice) {
                totalAmount += (vndPrice.salePrice * saleOrder.quantity);
            }
        }
        return totalAmount;
    }

    selectFilterSearch = (input, option) => {
        const resultText = option.props.children.props.children;
        return this.getResultSearch(resultText, input)
    }

    filterSearchAgentCustomer = (input, option) => {
        const getText = option.props.children[0];
        const getEmailPhone = option.props.children[2].props.children;
        const resultText = [getText, ...getEmailPhone].reduce((a, b) => a + b, '')
        return this.getResultSearch(resultText, input)
    }

    validateTour() {
        const { t } = this.props;
        const { saleOrder } = this.state;
        let validate = {
            required: {
                email: formatValidation(t('validation.statusCode.code.1'), t(`item.order.email`)),
                phoneNumber: formatValidation(t('validation.statusCode.code.1'), t(`item.order.phoneNumber`)),
                firstname: formatValidation(t('validation.statusCode.code.1'), t(`item.order.saleOrderFirstName`)),
                paymentType: formatValidation(t('validation.statusCode.code.1'), t(`item.order.paymentType`)),
                saleChannel: formatValidation(t('validation.statusCode.code.1'), t(`item.order.saleChannel`)),
                lastname: formatValidation(t('validation.statusCode.code.1'), t(`item.order.saleOrderLastName`)),
                // ftCode: formatValidation(t('validation.statusCode.code.1'), t(`item.order.ftCode`)),
            },
            isPhone: { phoneNumber: t('validation.isPhone') },
            minValueNumber: {
                // totalQuantity: t('validation.LessThenZero'),
            },
        };
        if(acceptFtCode.includes(saleOrder.paymentType)) {
            // validate.required.ftCode = formatValidation(t('validation.statusCode.code.1'), t(`item.order.ftCode`), true)
        }
        let valueValidate = {
            minLength: { phoneNumber: 8 },
            maxLength: { phoneNumber: 12 }
        };
        const result = multipleValidate(saleOrder, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    validateCustomer(customers) {
        const { t } = this.props;
        let validate = {
            required: {
                lastName: formatValidation(t('validation.statusCode.code.1'), ""),
                firstName: formatValidation(t('validation.statusCode.code.1'), ""),
            },
            isPhone: { phoneNumber: t('validation.isPhone') },
        };
        
        let validation = [];
        customers.forEach(item=> {
            validation.push(multipleValidate(item, validate));
        })
        this.setState({ validationCustomer: validation });
        return validation.findIndex(result=> Object.keys(result).length > 0) === -1 && this.state.isValidSubmarineQuantity;
    }

    validateSessionZone() {
        const { t } = this.props;
        const { saleOrder } = this.state;

        let validate = {
            required: {
                sessionId: formatValidation(t('validation.statusCode.code.1'), ""),
                zonePickupId: formatValidation(t('validation.statusCode.code.1'), ""),
                zoneReleaseId: formatValidation(t('validation.statusCode.code.1'), ""),
            },
        };

        const result = multipleValidate(saleOrder, validate);
        this.setState({ validationSessionZone: result });
        return Object.keys(result).length < 1;
    }

    onChangeCustomer = (fieldName, value, index) => {
        const { customerState } = this.state;
        customerState[index][fieldName] = value;
        this.setState({ customerState })
    }

    buildCustomerForm = (ticketState) => {
        const tickets = ticketState.filter(x=> x.vwType === ORDER.VINWONDER_ITEM_TYPE.SUBMARINE && x.quantity > 0);
        const count = sumBy(tickets.map(x=> x.quantity));
        this.setState({ customerState: [], validationCustomer: [], isValidSubmarineQuantity: true});
        if(count > 0){
            this.setState({isValidSubmarineQuantity: false});
            if(count <= ORDER.MAX_SUBMARINE){
                const customerData = [];
                const customerValidationData = [];
                tickets.forEach(item => {
                    for (let index = 0; index < item.quantity; index++) {
                        customerData.push({tourTicketItemId: item.id, vwType: item.vwType, siteCode: item.siteCode});
                        customerValidationData.push({});
                    }
                });
                
                this.setState({ customerState: customerData, validationCustomer: customerValidationData, isValidSubmarineQuantity: true});
            }
        }
    }
} 

SaleOrder.defaultProps = {
    onCancel: () => { },
    onSubmit: () => { },
    listFilters: {},
}


